module.exports = __webpack_public_path__ + "static/img/4495_phase_function_Paper_Points.a0546c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4495_phase_function_Paper_Points.png
// module id = n04z
// module chunks = 0